<template>
  <div class="row">
    <div class="col-12 evidence-container">
      <div class="row">
        <div class="col-md-8 col-sm-12">
          <title-bread-crumb :page="page" />
        </div>
        <div
          class="col-md-4 col-sm-12 text-right mt-sm-n0 mt-md-4 mt-sm-n3 mb-3 mb-md-0 mb-sm-3"
        >
          <ActionButton
            variant="outline-success mr-2"
            i="fas fa-arrow-circle-left"
            text="Regresar"
            @click="() => $router.back()"
          />
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <section-title
            content="Búsqueda Estudiantes Egresados con Impedimentos"
            :has-line="true"
          />
        </div>
      </div>

      <div class="row pt-3">
        <div class="col-12">
          <interview-advanced-search
            :model="model"
            :filters="filters"
            @SearchHandler="Search"
            @OnChangeHandler="OnChange"
          />
        </div>
      </div>

      <div
        class="
            row"
      >
        <div class="col-12">
          <InterviewResults
            results-divider-label="Listado de Estudiantes Egresados con Impedimentos"
            :questionnaire-status="model.questionnaireStatus"
            :results="studentExitList"
            :pagination="currentPaging"
            @GoToHandler="Search"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TitleBreadCrumb from '@/components/common/page/TitleBreadcrumb.vue';
import SectionTitle from '@/components/pei/shared/SectionTitle.vue';
import InterviewAdvancedSearch from './components/InterviewAdvancedSearch.vue';
import InterviewResults from './components/InterviewResults.vue';

import { modulesName } from '@/modules';
import { ACTION_TYPES } from '@/modules/student-follow-up-graduate/store/types';
import { createNamespacedHelpers } from 'vuex';
const { mapActions, mapGetters, mapState } = createNamespacedHelpers(
  modulesName.StudentFollowUpGraduateModuleName
);
import ActionButton from '@/components/common/ActionButton';

export default {
  name: 'GraduateInterview',
  data() {
    return {
      page: {
        icon: 'fas fa-user-circle',
        title: 'Entrevista Estudiante Egresado',
        routes: ['Estudiante', 'Entrevista Estudiantes Egresados'],
      },
      model: {
        // Student
        student: null,
        // Academic Years
        selectedAcademicYear: null,
        // Regions
        selectedRegion: null,
        // Districts
        selectedDistrict: null,
        // Schools
        selectedSchool: null,
        // Questionnaire Status
        selectedQuestionnaireStatus: null,
        advancedFilter: false,
      },
      pagination: {
        currentPage: 1,
        totalItemCount: 0,
        pageCount: 1,
        count: 0,
        pageSize: 10,
      },
    };
  },
  components: {
    SectionTitle,
    TitleBreadCrumb,
    InterviewAdvancedSearch,
    InterviewResults,
    ActionButton,
  },
  computed: {
    ...mapState({
      filters: (state) => {
        return {
          academicYears: state.filters.academicYears,
          regions: state.filters.regions,
          districts: state.filters.districts,
          schools: state.filters.schools,
          questionnaireStatus: state.filters.questionnaireStatus,
        };
      },
    }),
    ...mapGetters({
      studentExitList: 'getResults',
      currentFilters: 'getCurrentFilters',
      currentPaging: 'getPaging',
    }),
  },
  methods: {
    ...mapActions({
      getFilters: ACTION_TYPES.GET_BASIC_FILTERS,
      getRegions: ACTION_TYPES.GET_REGIONS,
      getDistrits: ACTION_TYPES.GET_DISTRICTS,
      getSchools: ACTION_TYPES.GET_SCHOOLS,
      getInterviews: ACTION_TYPES.GET_INTERVIEWS,
    }),
    async OnChange(selectedType, value) {
      const selectedValue = value?.id;
      if (selectedType === 'academicYear') {
        this.model.selectedRegion = null;
        this.model.selectedDistrict = null;
        this.model.selectedSchool = null;
        if (selectedValue) {
          await this.getRegions({AcademicYearId: selectedValue});
        }
      }

      if (selectedType === 'region') {
        this.model.selectedDistrict = null;
        this.model.selectedSchool = null;
        if (selectedValue) {
          await this.getDistrits({
            AcademicYearId: this.model.selectedAcademicYear.id,
            RegionId: selectedValue,
          });
        }
      } else if (selectedType === 'district') {
        this.model.selectedSchool = null;
        if (selectedValue) {
          await this.getSchools({
            AcademicYearId: this.model.selectedAcademicYear.id,
            RegionId: this.model.selectedRegion.id,
            DistrictId: selectedValue,
          });
        }
      }
    },
    Search(page) {
      this.pagination.currentPage = page ? page : 1;

      let studentExitInputDto = {
        ...this.model,
        currentPage: this.pagination.currentPage,
        pageSize: this.pagination.pageSize,
      };

      // FirstName
      if (
        isNaN(this.model.student) &&
        (typeof this.model.student === 'string' ||
          this.model.student instanceof String)
      ) {
        studentExitInputDto.firstName = this.model.student;
      }
      // SIE
      else if (this.model.student && this.model.student.length == 8) {
        studentExitInputDto.studentSieId = this.model.student;
      }
      // Reg
      else if (this.model.student && this.model.student.length == 10) {
        studentExitInputDto.regStudentId = this.model.student;
      }

      this.getInterviews(studentExitInputDto);
    },
  },
  watch: {
    'filters.academicYears': async function (newVal, oldVal) {
      if(!this.model.selectedAcademicYear) {
        this.model.selectedAcademicYear = newVal[0];
      }

      if(this.model.selectedAcademicYear !== this.currentFilters.selectedAcademicYear) {
        this.currentFilters.selectedAcademicYear = this.model.selectedAcademicYear;

        this.model.selectedRegion = this.filters.regions.length === 1 ? this.filters.regions[0] : null;

        if (this.model.selectedRegion && !this.model.selectedDistrict) {
          await this.OnChange('region', this.model.selectedRegion)
          this.model.selectedDistrict = this.filters.districts.length === 1 ? this.filters.districts[0] : null;

          if (this.model.selectedDistrict && !this.model.selectedSchool) {
            await this.OnChange('district', this.model.selectedDistrict)
            this.model.selectedSchool = this.filters.schools.length === 1 ? this.filters.schools[0] : null;
          }
        }
      }

      let searchText = '';
      if (this.currentFilters.regStudentId) {
        searchText = this.currentFilters.regStudentId;
      }
      if (this.currentFilters.studentSieId) {
        searchText = this.currentFilters.studentSieId;
      }
      if (this.currentFilters.firstName) {
        searchText = this.currentFilters.firstName;
      }

      this.model.student = searchText;
      this.model.selectedQuestionnaireStatus = this.currentFilters.selectedQuestionnaireStatus;
      this.model.advancedFilter = this.currentFilters.advancedFilter;

      this.Search();
    }
  },

  async mounted() {
    //Load basic filters
    //Set by default current academic year ()
    await this.getFilters({AcademicYearId: this.currentAcademicYear().id});
  },
};
</script>

<style scoped>
.badge.no-interview {
  height: 32px;
  background: #f8eb7f 0% 0% no-repeat padding-box;
  border-radius: 18px;
  opacity: 1;
  text-align: center;
  font: Bold 16px/21px Lato;
  letter-spacing: 0;
  color: #11291b;
}
.badge.completed {
  height: 32px;
  background: #a3e5b3 0% 0% no-repeat padding-box;
  border-radius: 18px;
  opacity: 1;
  text-align: center;
  font: Bold 16px/21px Lato;
  letter-spacing: 0;
  color: #11291b;
}
.btn-setting {
  background: #ff7058 0% 0% no-repeat padding-box;
  border-radius: 4px;
  border: 0px !important;
  color: #ffffff;
  opacity: 1;
}
.btn-setting-off {
  background-color: #f4f6f3;
  border-radius: 4px;
  border: 0px !important;
  color: #3f5b60;
}

.search-bar {
  background: #f4f6f3 0% 0% no-repeat padding-box;
  border-radius: 5px;
  opacity: 1;
}

.title-divider {
  border: 1px solid #b5c3bc;

  opacity: 1;
}
.title-content {
  background: #3f5b60 0% 0% no-repeat padding-box;
  border-radius: 21px;
  opacity: 1;
  text-align: center;
  font: Bold 17px/23px Lato;
  letter-spacing: 0;
  color: #ffffff;
}
.filter-content {
  font: Bold 14px/17px Lato;
  letter-spacing: 0;
  color: #aab7b1;
  opacity: 1;
}

.no-info {
  background: #f7f7f7 0% 0% no-repeat padding-box;
  border-radius: 5px;
  opacity: 1;
  border-left-style: solid;
  border-color: #e8e8e8;
  border-width: 0;
}
.no-info-text {
  text-align: left;
  font: Bold 16px/22px Lato;
  letter-spacing: 0;
  color: #727272;
  opacity: 1;
}
.no-info-icon {
  color: #727272;
  font-size: 32px;
}

.interview-status {
  height: 32px;
  background: #f8eb7f 0% 0% no-repeat padding-box;
  border-radius: 18px;
  opacity: 1;
  text-align: center;
  font: Bold 16px/21px Lato;
  letter-spacing: 0;
  color: #11291b;
}
.egress-interview {
  background: #f7f7f7 0% 0% no-repeat padding-box;
  border-radius: 5px;
  opacity: 1;

  border-left-style: solid;
  border-color: #f8eb7f;
  border-width: 4px;
}

.btn-dropdown-actions {
  text-align: center;
  font-family: 'Lato', sans-serif;
  font-weight: 400;
  font-size: 1rem;
  color: rgb(12, 19, 16);
  border-radius: 4px;
  margin-right: 0px;
  border: 1px solid #2db782;
}
.dropdown-menu {
  margin-top: 1rem;
}

.dropdown-item {
  font: Regular 16px/19px Lato;
}

.dropdown-item i {
  margin-right: 1rem;
}

.drop-item {
  font-family: 'Lato', sans-serif;
  font-weight: 400;
  font-size: 0.9375rem;
  color: #11291b;
  text-align: inherit;
  white-space: nowrap;
  display: block;
  padding: 0.29rem 1.5rem;
  clear: both;
}

.dropdown-action-divider {
  border-top-width: 1px;
  border-top-style: solid;
  border-color: #e2e2e2;
  margin-left: 5%;
  margin-right: 5%;
}

.settings-button {
  align-content: center;

  background: #ff7058 0% 0% no-repeat padding-box;
  border-radius: 4px;
  opacity: 1;
}

.icon {
  font-size: 35px;
  height: 60px;
  width: 60px;
  border: solid 3px;
  border-radius: 127px;
  padding-top: 8px;
  padding-right: 4px;
  color: #e2e2e2;
}

.egress-interview.no-interview {
  border-color: #f8eb7f;
}

.egress-interview.completed {
  border-color: #a3e5b3;
}

.egress-interview.in-process {
  border-color: #d5b89a;
}
</style>
<style>
.was-Invalidated {
  top: 22px !important;
}
.student-search-alert-error.no-border {
  top: 22px !important;
  padding-bottom: 1px;
}

@media (min-width: 1440px) {
  .was-Invalidated {
    top: 10px !important;
  }
  .student-search-alert-error.no-border {
    top: 10px !important;
    padding-bottom: 1px;
  }
}
</style>
